module.exports = __webpack_public_path__ + "static/car-pc/img/active.dac74af2.svg";